import { translator } from "./i18n";

export const STEP_SEPARATOR = ":";

export const GROUP_PROTOCOL = "protocol";
export const GROUP_QUESTION_RESPONSE = "question_response";
export const STEP_CODE_QUESTION = "question";
export const STEP_CODE_INIT_LOOPER = "init_looper";
export const STEP_CODE_LOOPER = "looper";
export const STEP_CODE_IDENTIFY = "STEP_CODE_IDENTIFY";

export const PHONE_DEFAULT_COUNTRY = "FR";
export const PHONE_ALLOWED_COUNTRIES = [
  "FR",
  "DE",
  "ES",
  "BE",
  "IT",
  "CH",
  "GF",
  "RE",
  "MC",
  "GP",
  "MF",
  "BL",
  "CI"
];

export const CURRENCY_SYMBOLS = {
  usd: "$",
  gbp: "£",
  eur: "€"
};

export const DATE_FORMAT_INTL = "yyyy-MM-dd";

export const weekDays = [
  { value: 1, label: "W_STEP3_MENU_LIST_LUNDI" },
  { value: 2, label: "W_STEP3_MENU_LIST_MARDI" },
  { value: 3, label: "W_STEP3_MENU_LIST_MERCREDI" },
  { value: 4, label: "W_STEP3_MENU_LIST_JEUDI" },
  { value: 5, label: "W_STEP3_MENU_LIST_VENDREDI" },
  { value: 6, label: "W_STEP3_MENU_LIST_SAMEDI" },
  { value: 0, key: 8, label: "W_STEP3_MENU_LIST_DIMANCHE" }
];

export const months = [
  { value: 1, label: "W_STEP3_MENU_LIST_JANVIER" },
  { value: 2, label: "W_STEP3_MENU_LIST_FEVRIER" },
  { value: 3, label: "W_STEP3_MENU_LIST_MARS" },
  { value: 4, label: "W_STEP3_MENU_LIST_AVRIL" },
  { value: 5, label: "W_STEP3_MENU_LIST_MAI" },
  { value: 6, label: "W_STEP3_MENU_LIST_JUIN" },
  { value: 7, label: "W_STEP3_MENU_LIST_JUILLET" },
  { value: 8, label: "W_STEP3_MENU_LIST_AOUT" },
  { value: 9, label: "W_STEP3_MENU_LIST_SEPTEMBRE" },
  { value: 10, label: "W_STEP3_MENU_LIST_OCTOBRE" },
  { value: 11, label: "W_STEP3_MENU_LIST_NOVEMBRE" },
  { value: 12, label: "W_STEP3_MENU_LIST_DECEMBRE" }
];

export const getWeekDays = () => {
  let result = [];
  weekDays.forEach(elem => {
    result.push({ value: elem.value, label: translator()._(elem.label) });
  });
  return result;
};

export const getMonths = () => {
  let result = [];
  months.forEach(elem => {
    result.push({ value: elem.value, label: translator()._(elem.label) });
  });
  return result;
};

export const timeSlot = () => {
  const _timeSlot = [];

  const padHour = hour => (hour + "").padStart(2, "0");

  for (let h = 6; h <= 20; h += 2) {
    _timeSlot.push({
      value: `${padHour(h)}-${padHour(h + 1)}`,
      label: `${padHour(h)}h / ${padHour(h + 2)}h`
    });
  }

  return _timeSlot;
};

export const inWeeks = () => {
  const _inWeeks = [];
  for (let w = 1; w <= 15; w++) {
    _inWeeks.push({
      value: w,
      key: `${w}-week`,
      label: `${w} ${
        w === 1 ? translator()._("W_WEEK") : translator()._("W_WEEKS")
      }`
    });
  }

  return _inWeeks;
};
